import React from 'react';
import cn from 'classnames';
import DispexButton from '../DispexButton/DispexButton';
import styles from './RoundedButton.module.scss';

const RoundedButton = ({ className, type, text, iconRight, iconLeft, ...props }) => {
  return (
    <DispexButton {...props} type={type} className={cn(styles.root, className)}>
      {iconLeft && iconLeft}
      {text}
      {iconRight && iconRight}
    </DispexButton>
  );
};

export default RoundedButton;
